/***
 *
 *   USER
 *   shows the current user
 *   if user belongs to more than one account they can switch accounts here
 *
 **********/

import { AuthContext, Button, HoverNav, ViewContext } from "components/lib";
import { useContext } from "react";
import Style from "./user.module.scss";

export function User(props) {
  const authContext = useContext(AuthContext);
  const viewContext = useContext(ViewContext);
  const userAccount = authContext.user?.accounts?.find(
    (x) => x.id === authContext.user?.account_id
  );

  return (
    <div className={Style.user}>
      {authContext.user && (
        <>
          <div className={Style.name}>
            Welcome, {authContext.user?.name} |{" "}
            <span onClick={authContext.signout}>Signout</span>
          </div>
          <div className={Style.copy}>Cover Badger</div>
        </>
      )}

      {authContext.user?.accounts?.length > 1 && (
        <HoverNav
          dark
          icon="user"
          label={userAccount.name}
          className={Style.hoverNav}
          align="right"
        >
          {authContext.user.accounts.map((account) => {
            return (
              <Button
                key={account.id}
                text={account.name}
                action={() => {
                  viewContext.setLoading(true);
                  authContext.switchAccount(account.id);
                }}
              />
            );
          })}
        </HoverNav>
      )}
    </div>
  );
}
